import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const PanelWrapper = styled(Box)`
  display: flex;
`;
